import AcceptedLoanOffer from '@/pages/AcceptedLoanOffer';
import AggregatorBrokerAppList from '@/pages/Aggregator/AggregatorBrokerAppList';
import AggregatorBrokerList from '@/pages/Aggregator/AggregatorBrokerList';
import AggregatorBrokerSignUp from '@/pages/Aggregator/AggregatorBrokerSignUp';
import AggregatorForgotPassword from '@/pages/Aggregator/AggregatorForgotPassword';
import AggregatorIndex from '@/pages/Aggregator/AggregatorIndex';
import AggregatorNewPassword from '@/pages/Aggregator/AggregatorNewPassword';
// Aggregator Pages
import AggregatorSignIn from '@/pages/Aggregator/AggregatorSignIn';
import AggregatorThanksPage from '@/pages/Aggregator/AggregatorThanksPage';
import Meta from 'vue-meta';
import NotFound from '@/pages/NotFound';
import Router from 'vue-router';
import TomCTOPage from '@/pages/TomCTOPage';
import TomCTOPage2 from '@/pages/TomCTOPage2';
import Vue from 'vue';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: 'history',
  routes: [
    // TomCTOPage (reference documents page)
    {
      path: '/borrower-consents',
      name: 'tompage',
      component: TomCTOPage,
    },
    // TomCTOPAge2 (broker interest form)
    {
      path: '/accreditation',
      name: 'tompage2',
      component: TomCTOPage2,
    },
    // AcceptedLoanOffer Page
    {
      path: '/accepted-loan-details/:token',
      name: 'Accepted Loan Offer',
      component: AcceptedLoanOffer,
    },
    // Aggregator
    {
      path: '/aggregator/sign-in',
      name: 'AggregatorSignIn',
      component: AggregatorSignIn,
      // if user is aggregator and is logged in, they should not see the sign in page
    },
    {
      path: '/aggregator/forgot-password',
      name: 'AggregatorForgotPassword',
      component: AggregatorForgotPassword,
      meta: {
        requiresGuest: true,
      },
      fallbackUrl: '/aggregator/sign-in',
    },
    {
      path: '/aggregator/new-password/:id',
      name: 'AggregatorNewPassword',
      component: AggregatorNewPassword,
      meta: {
        requiresGuest: true,
      },
      fallbackUrl: '/aggregator/sign-in',
    },
    {
      path: '/aggregator',
      name: 'AggregatorIndex',
      component: AggregatorIndex,
      meta: {
        requiresAuth: true,
        userType: 'aggregator',
        fallbackUrl: '/aggregator/sign-in',
      },
      children: [
        {
          path: 'brokers',
          name: 'AggregatorBrokerListPage',
          component: AggregatorBrokerList,
          meta: {
            requiresAuth: false,
            userType: 'aggregator',
            fallbackUrl: '/aggregator/sign-in',
          },
        },
        {
          path: 'broker/:id',
          name: 'AggregatorBrokerAppList',
          component: AggregatorBrokerAppList,
          meta: {
            requiresAuth: false,
            userType: 'aggregator',
            fallbackUrl: '/aggregator/sign-in',
          },
        },
        {
          path: 'broker-creation-success',
          name: 'AggregatorThanksPage',
          component: AggregatorThanksPage,
          meta: {
            requiresAuth: false,
            userType: 'aggregator',
            fallbackUrl: '/aggregator/sign-in',
          },
        },
        {
          path: ':brokerId',
          props: true,
          name: 'AggregatorBrokerSignUp',
          component: AggregatorBrokerSignUp,
          meta: {
            requiresAuth: true,
            userType: 'aggregator',
            fallbackUrl: '/aggregator/sign-in',
          },
        },
      ],
    },
    {path: '/', redirect: {name: 'AggregatorSignIn'}},
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js